export default "__VITE_ASSET__CyiShPlL__"